
import React from 'react';
import DynamicForm from '@/components/signup/DynamicForm';
import { SignupFormConfig, SignupFormField } from '@/schemas/signupFormSchema';

interface SignupFormProps {
  onSubmit: (data: Record<string, any>) => void;
  isLoading: boolean;
  isCurrentPlan?: boolean;
}

const SignupForm = ({ onSubmit, isLoading, isCurrentPlan = false }: SignupFormProps) => {
  // Define a form configuration that adheres to the SignupFormField type constraints
  const formConfig: SignupFormConfig = {
    formTitle: "Driver Account Signup",
    fields: [
      { id: "1", name: "name", email: "name@field.com", label: "Full Name", type: "text", visible: true, required: true, defaultValue: "" },
      { id: "2", name: "email", email: "email@field.com", label: "Email", type: "email", visible: true, required: true, defaultValue: "" },
      { id: "3", name: "password", email: "password@field.com", label: "Password", type: "password", visible: true, required: true, defaultValue: "" },
      { id: "4", name: "confirmPassword", email: "confirmPassword@field.com", label: "Confirm Password", type: "password", visible: true, required: true, defaultValue: "" },
      { id: "5", name: "terms", email: "terms@field.com", label: "Terms and Conditions", type: "checkbox", visible: true, required: true, defaultValue: "" }
    ],
    ccEmail: "",
    enableCcEmail: false,
    includeTimestamp: true,
    validateAccountNumber: false,
    validateLicenseNumber: false
  };

  return (
    <DynamicForm
      onSubmit={onSubmit}
      isLoading={isLoading}
      formConfig={formConfig}
      isCurrentPlan={isCurrentPlan}
    />
  );
};

export default SignupForm;
